/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface RunUpdateUpgradeRequestDto
 */
export interface RunUpdateUpgradeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof RunUpdateUpgradeRequestDto
     */
    targetVersion: string;
    /**
     * 
     * @type {boolean}
     * @memberof RunUpdateUpgradeRequestDto
     */
    backupConfirmed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RunUpdateUpgradeRequestDto
     */
    password: string;
    /**
     * 
     * @type {boolean}
     * @memberof RunUpdateUpgradeRequestDto
     */
    ignoreLoggedInUsers?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RunUpdateUpgradeRequestDto
     */
    $type?: RunUpdateUpgradeRequestDtoTypeEnum;
}


/**
 * @export
 */
export const RunUpdateUpgradeRequestDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCsoPortalDtoRunUpdateUpgradeRequestDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.CsoPortal.Dto.RunUpdateUpgradeRequestDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type RunUpdateUpgradeRequestDtoTypeEnum = typeof RunUpdateUpgradeRequestDtoTypeEnum[keyof typeof RunUpdateUpgradeRequestDtoTypeEnum];



/**
 * Check if a given object implements the RunUpdateUpgradeRequestDto interface.
 */
export function instanceOfRunUpdateUpgradeRequestDto(value?: unknown): value is RunUpdateUpgradeRequestDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(RunUpdateUpgradeRequestDtoTypeEnum)[0];
}

export function RunUpdateUpgradeRequestDtoFromJSON(json: any): RunUpdateUpgradeRequestDto {
    return RunUpdateUpgradeRequestDtoFromJSONTyped(json, false);
}

export function RunUpdateUpgradeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunUpdateUpgradeRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'targetVersion': json['targetVersion'],
        'backupConfirmed': json['backupConfirmed'] == null ? undefined : json['backupConfirmed'],
        'password': json['password'],
        'ignoreLoggedInUsers': json['ignoreLoggedInUsers'] == null ? undefined : json['ignoreLoggedInUsers'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function RunUpdateUpgradeRequestDtoToJSON(value?: RunUpdateUpgradeRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'targetVersion': value['targetVersion'],
        'backupConfirmed': value['backupConfirmed'],
        'password': value['password'],
        'ignoreLoggedInUsers': value['ignoreLoggedInUsers'],
        '$type': value['$type'],
    });
}

